import * as React from "react";
import {BsPaletteFill} from "react-icons/bs";
import {FaPaintBrush} from "react-icons/fa";
import {Button, Card} from "react-bootstrap";
import {useCustomizedItemQuery} from "../../../hooks/useCustomizedItemQuery";

export const CustomizableNotice = () => {
    const {model: {path}} = useCustomizedItemQuery();

    // If there is no path, don't render anything
    if (!path) return <></>;

    return (
        <Card body className="my-3">
            <div className="ms-3 d-flex align-items-center ">
                <div className="ms-2 me-4">
                    <span className="position-relative">
                        <BsPaletteFill size={42}
                                       className="text-info position-absolute top-50 start-50 translate-middle"
                                       style={{opacity: 0.3}}
                                       aria-hidden="true"/>
                        <FaPaintBrush size={28}
                                      aria-hidden="true"
                                      className="text-info position-absolute"
                                      style={{top: '-22px', left: '-6px'}}/>
                    </span>
                </div>
                <div className="ms-2">
                    <span className="fw-bold text-dark ">Make It Your Own with Custom Printing!</span>
                    <Button variant="link" href={path} className="p-0 text-start" tabIndex={0}>
                        <span className="d-block">Click here to view custom printing options</span>
                    </Button>
                </div>
            </div>
        </Card>
    )
}